var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFlashSale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.33333C0 2.38782 2.38781 0 5.33333 0H18.6667C21.6122 0 24 2.38781 24 5.33333V18.6667C24 21.6122 21.6122 24 18.6667 24H5.33333C2.38782 24 0 21.6122 0 18.6667V5.33333Z",
    fill: "#FFDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8889 6.22201L8.88886 4.88867L7.11108 12.8887H9.77775L7.55553 20.4442L16 11.9998H12.4444L16.8889 6.22201Z",
    fill: "#ED145B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlashSale);
export default __webpack_public_path__ + "static/media/ic_flash_sale.67eda1d6b2f8d29ebdc9cc9b3320ea8c.svg";
export { ForwardRef as ReactComponent };